import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/models/entities/audit';
import { JsonPipe } from '@angular/common';

@Component({
    selector: 'app-audit-diff-formatter',
    templateUrl: './audit-diff-formatter.component.html',
    styleUrls: ['./audit-diff-formatter.component.scss'],
    standalone: true,
    imports: [
        JsonPipe,
    ],
})
export class AuditDiffFormatterComponent implements OnInit
{

    @Input() audit: Audit;

    constructor() {
    }

    ngOnInit(): void {
    }

}
